module.exports = __webpack_public_path__ + "media/images/iconSocialMail__okGreen--dark-1fa7926b790246e59c465ca7314b6f54.png";